export default "__VITE_ASSET__BxIwI8Ql__"